import './tags/counter-label';
import './tags/event-button';

riot.tag2('riot-app', '<div class="panel panel-default"> <div class="panel-heading"> <h3 class="panel-title">{this.opts.framework}</h3> </div> <div class="panel-body"> <event-button event="{increment}" framework="{this.opts.framework}" display="{\'+\'}"></event-button> <event-button event="{decrement}" framework="{this.opts.framework}" display="{\'-\'}"></event-button> </div> <div class="panel-footer"> <div each="{state.frameworkScores}"> <counter-label label="{name}" value="{score}"></counter-label> </div> </div> </div>', '', '', function(opts) {

		let store = this.opts.store;

		this.state = store.getState().toJS();

		store.subscribe(() => {
			this.state = store.getState().toJS();
			this.update();
		});

		const actionCreators = this.opts.actionCreators;

		this.increment = (framework) => {
			store.dispatch(actionCreators.increment(framework));
		};

		this.decrement = (framework) => {
			store.dispatch(actionCreators.decrement(framework));
		};

});


// WEBPACK FOOTER //
// ./src/riot/riot-app.tag